import Header from '../../../shared/components/header/page';
import Content from '../../../shared/components/content/page';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useExpenseMutations } from '../../../shared/tanstack/expenses/mutations';
import { useMutation } from '@tanstack/react-query';
import { InvalidCircleIdError } from '../../../shared/models/errors/invalid-circle-id-error';
import { useExpenseContext } from '../../../contexts/expense/expense-context';
import amountService from '../../../shared/services/amount.service';
import { getInputs } from '../../../dynamic-forms/utils/get-inputs';
import { DynamicForm } from '../../../dynamic-forms/dynamic-form';
import { Expense } from '../../../shared/models/expense';

const AddEditSettlementStep2 = () => {
	const navigate = useNavigate();
	const { id: circleId } = useParams();
	if (!circleId) {
		throw new InvalidCircleIdError();
	}
	const { expense, getFinalExpense } = useExpenseContext();
	const { addExpenseMutation, updateExpenseMutation } = useExpenseMutations(circleId);

	const { mutate: addExpense } = useMutation(addExpenseMutation);
	const { mutate: updateExpense } = useMutation(updateExpenseMutation);

	const onSettleAmount = (data: Expense) => {
		const finalExpense = getFinalExpense();
		if (finalExpense) {
			data.dateTime = data.dateTime ? new Date(data.dateTime) : undefined;
			const creditors = (expense?.creditors ?? []).map(x => ({
				...x,
				amount: amountService.getAmount(data.amount),
				currency: (x.currency?.length ?? 0) > 0 ? (x.currency ?? '₹') : '₹',
			}));
			const debtors = (expense?.debtors ?? []).map(x => ({
				...x,
				amount: amountService.getAmount(data.amount),
				currency: (x.currency?.length ?? 0) > 0 ? (x.currency ?? '₹') : '₹',
			}));

			const settlment = {
				...finalExpense,
				dateTime: data.dateTime,
				amount: amountService.getAmount(data.amount),
				creditors: creditors,
				debtors: debtors,
			};
			if (finalExpense.id) {
				updateExpense(settlment);
				navigate(-3);
			} else {
				addExpense(settlment);
				navigate(-2);
			}
		}
	};

	if (expense) {
		return (
			<>
				<Header title="Details" subtitle={`Enter the details of the settlement.`} />
				<Content>
					<DynamicForm
						{...getInputs('add-edit-settlement')}
						initialValues={expense}
						onSubmit={onSettleAmount}
						submitButtonType={'Button'}
						submitButtonTitle={'Settle up'}
					/>
				</Content>
			</>
		);
	}
};

export default AddEditSettlementStep2;
